import { t } from '@/locale/index.js'
import { applyColumnLabels, applyOptionLabels, applySearchLabels } from '@/utils/listPageI18n.js'

const CAPTAIN_SPECIAL_COLUMNS = {
  id: 'taskSpecial.taskId',
  title: 'field.title',
  real_name: 'taskSpecial.publisher',
  description: 'taskSpecial.description',
  score: 'detail.score',
  staff: 'taskSpecial.staffLimit',
  status: 'field.status',
  start_time: 'taskSpecial.startTime',
  end_time: 'taskSpecial.endTime',
  operation: 'table.operation',
}

/** 队长端特殊任务列表 */
export function applyCaptainSpecialListLabels({ searchData, columns, statusOptions }) {
  applySearchLabels(searchData, {
    keywords: { labelKey: 'field.keywords' },
    status: { labelKey: 'field.status' },
  })
  applyColumnLabels(columns, CAPTAIN_SPECIAL_COLUMNS)
  applyOptionLabels(statusOptions, {
    1: 'taskSpecial.published',
    0: 'taskSpecial.unpublished',
  })
}

export function applyCaptainSpecialFormRules(rules) {
  if (rules.title?.[0]) rules.title[0].message = t('taskSpecial.needTitle')
  if (rules.description?.[0]) rules.description[0].message = t('taskSpecial.needDesc')
  if (rules.url?.[0]) rules.url[0].message = t('taskSpecial.needUpload')
  if (rules.start_time?.[0]) rules.start_time[0].message = t('taskSpecial.needStartTime')
  if (rules.end_time?.[0]) rules.end_time[0].message = t('taskSpecial.needEndTime')
  if (rules.score?.[0]) rules.score[0].message = t('taskSpecial.needScore')
  if (rules.staff?.[0]) rules.staff[0].message = t('taskSpecial.needStaff')
  if (rules.status?.[0]) rules.status[0].message = t('taskSpecial.needStatus')
}

export { t }
